import { Request } from '../../../httpClient/serverApi/requests/Request';
import { IEmptyResult } from '../../../httpClient/serverApi/types/IResponse';
import { ISetNameParams } from '../../../ts/ServerApi/types/actionParams';

export class RenameDatasourceRequest extends Request<ISetNameParams, IEmptyResult> {
  constructor(params: ISetNameParams) {
    super('renameDatasource', params);
  }
}
